import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import cx from "classnames";
import _ from "lodash";

import { fetchPersonalizationLead, invalidatePersonalization } from "actions/personalization";

import { LeadsList } from "./components/LeadsList";
import { PersonalizationSettings } from "./components/PersonalizationSettings";
import StoryboardContext from "components/Storyboard/context";
import { LeadCreation, LeadSelection } from "./components/modals";
import { LoadingMessage } from "../leadReports/components";

import { Row, Col, Dropdown } from "react-bootstrap";

import styles from "./personalization.module.scss";
import { invalidateVariables } from "actions/variables";


export default function Personalization() {
  const dispatch = useDispatch();

  const [activeLead, setActiveLead] = useState(null);

  const loading = useSelector((state) =>
    _.get(state, `personalization.leads.loading`, false)
  );

  const leads = useSelector((state) => _.get(state, "personalization.leads.items", [])) ||
    [];

  const activeLeadData = leads.find((lead) => lead.id === activeLead?.id);

  const storyboardContext = React.useContext(StoryboardContext);
  const storyboardId = useSelector((state) =>
    _.get(
      state,
      "storyboards.storyboard.item.id",
      _.get(storyboardContext, "id")
    )
  );

  useEffect(() => {
    if (storyboardId) {
      const req ={
        storyboard: storyboardId,
        sort: "modified_date",
        order: "DESC",
      }
      dispatch(fetchPersonalizationLead(req, 0, 10));
    }

    return () => {
      dispatch(invalidateVariables())
      dispatch(invalidatePersonalization())
    };
    
  }, []);

  const handleActiveLead = (lead) => {
    if (!_.isEqual(lead, activeLead)) {
      setActiveLead(lead);
    }
  };

  return (
    <div className={styles.personalizationContent}>
      <header className={styles.contentHeader}>
        <span className={styles.header}>Personalization</span>
        <span className={styles.description}>One space to manage them all</span>
      </header>
      {loading && leads && leads.length === 0 &&(
        <div className={cx(styles.loader, styles.modalLoader)}>
          <LoadingMessage className={styles.loadingMessage} />
        </div>
      )}
      {!loading && leads && leads.length === 0 && (
        <PersonalizationEmptyMessage  storyboard={storyboardId}/>
      )}
      {leads && leads.length > 0 && (
        <Row className={styles.personalizationRow}>
          <Col md={5} className={cx(styles.leadsColumn)}>
            <LeadsList
              handleActiveLead={handleActiveLead}
              activeLead={activeLead}
              storyboard={storyboardId}
            />
          </Col>
          <Col md={7} className={cx(styles.settingsColumn)}>
            <PersonalizationSettings activeLead={activeLeadData} storyboard={storyboardId} />
          </Col>
        </Row>
      )}
    </div>
  );
}

export const PersonalizationEmptyMessage = ({storyboard}) => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(null);
  const creating = useSelector((state) =>
    _.get(state, `personalization.leads.creating`, false)
  );

  const handleFetchLeads = () => {
    const request = {
      storyboard: storyboard,
      sort: "modified_date",
      order: "DESC",
    };

    dispatch(fetchPersonalizationLead(request, 0, 10));
  }

  return (
    <div className={styles.emptyMediaContainer}>
      <div className={styles.emptyMessage}>
        <img
          className={cx(styles.emptyMediaImage)}
          src=""
          alt="emptyMedia_image"
        />
        <div className={styles.errorMessageContent}>
        <Dropdown autoClose="outside" className={styles.addLeadsButton}>
          <Dropdown.Toggle disabled={creating} variant="success">
            <i className={cx(styles.icon, "cleverstory-plus")} />
            Add Leads
          </Dropdown.Toggle>
          <Dropdown.Menu
            className={`${styles.customDropdownMenu} dropdown-menu-end`}
          >
            <Dropdown.Item onClick={() => setShow("create")}>
              Create a Recipient
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setShow("select")}>
              Select Leads
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
          <div className={styles.errorMessageTitle}>
            <h2 className={styles.heading}>Weather forecast</h2>
          </div>
          <div className={styles.errorMessageSubText}>
            <span>
              Clear skies and <br /> empty screens
            </span>
          </div>
        </div>
      </div>
      <LeadCreation
        show={show === "create"}
        onClose={() => {
          setShow(null);
        }}
        handleFetchLeads={handleFetchLeads}
      />
      <LeadSelection
        show={show === "select"}
        onClose={() => {
          setShow(null);
        }}
        handleFetchLeads={handleFetchLeads}
      />
    </div>
  );
};
